<template>
  <el-dialog
    title="發佈投稿"
    :visible.sync="visible"
    width="375px"
    append-to-body
    :show-close="true"
    center
    custom-class="publish-dialog"
    :close-on-click-modal="false"
  >
    <div class="dialog-main">
      <div class="input">
        <el-input
          type="textarea"
          v-model="message"
          rows="1"
          maxlength="10"
          placeholder="點擊輸入文字(10字以內)"
          show-word-limit
          resize="none"
        >
        </el-input>
      </div>
      <div>
        <el-upload
          v-loading="isUploading"
          element-loading-text=""
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          class="avatar-uploader"
          :http-request="uploadAction"
          action=""
          auto-upload
          :disabled="isUploading"
          :show-file-list="false"
          :on-success="setImg"
          :before-upload="beforeUpload"
        >
          <img v-if="imgUrl" :src="imgUrl" class="avatar" />
          <img class="img-add" v-else src="./images/add.png" />
        </el-upload>
      </div>
      <button class="btn-publish" type="button" @click="publish()">
        發佈
      </button>
    </div>
  </el-dialog>
</template>
<script>
import { uploadImageToS3 } from '@/api';

export default {
  name: 'PublishDialog',
  props: {
    votesType: {
      type: String
    },
    uuid: {
      type: String
    }
  },
  data() {
    return {
      message: '',
      imgUrl: '',
      loading: false,
      isUploading: false,
      visible: false
    };
  },
  computed: {},
  mounted() {},
  methods: {
    show() {
      this.message = '';
      this.imgUrl = '';
      this.loading = false;
      this.isUploading = false;
      this.visible = true;
    },
    closeDialog() {
      this.visible = false;
    },
    uploadAction({ file }) {
      const fd = new FormData();
      fd.append('file', file);
      return uploadImageToS3(fd);
    },
    beforeUpload() {
      this.isUploading = true;
    },
    setImg(event) {
      this.imgUrl = event.data;
      this.isUploading = false;
    },
    publish() {
      if (!this.message) {
        this.$message('請輸入投稿內容');
        return;
      }
      if (!this.imgUrl) {
        this.$message('請上傳圖片');
        return;
      }
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$http
        .post('/votes/create', {
          userUuid: this.uuid,
          votesType: this.votesType,
          imageUrl: this.imgUrl,
          content: this.message
        })
        .then(() => {
          this.$message.success('投稿成功');
          this.$emit('success');
          this.closeDialog();
        })
        .catch(() => {
          this.$message('投稿失敗');
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created() {}
};
</script>
<style lang="scss">
.publish-dialog {
  width: 375px;
  height: 449px;
  background: #ffffff;
  border-radius: 20px;
  .el-dialog__title {
    font-weight: 600;
    font-size: 17px;
    line-height: 24px;
    text-align: center;
    color: #2e2e2e;
  }
  .el-textarea__inner {
    background: #f2f2f2;
    border-radius: 8px;
    border: none;
    height: 111px;
    padding: 16px;
    margin-bottom: 20px;
    .el-input__count {
      bottom: 16px;
    }
  }

  .avatar-uploader {
    background: #f9f9f9;
    border-radius: 12px;
    width: 110px;
    height: 110px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .img-add {
      width: 22px;
      height: 22px;
    }
  }
  .btn-publish {
    margin-top: 56px;
    width: 339px;
    height: 50px;
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
    color: #222c43;
    background: #fed838;
    border-radius: 44px;
  }
}
</style>
